import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@assets/images/Modal_Success.png'


const _hoisted_1 = {
  key: 0,
  class: "testDriveModal--cont ask-us-form"
}
const _hoisted_2 = { class: "modal-ask-us-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "Paragraphs" }
const _hoisted_9 = { class: "ParagraphParkGray-Subhead" }
const _hoisted_10 = { class: "ParagraphParkGray-BodyLG" }
const _hoisted_11 = {
  action: "",
  role: "form",
  id: "form"
}
const _hoisted_12 = { class: "testDriveModal" }
const _hoisted_13 = { class: "form-group-nested" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  class: "form-label",
  for: "inputFirstnameAboutThisCar",
  role: "presentation",
  id: "labelForFirstNameAboutCar"
}
const _hoisted_16 = {
  class: "error_message hide-text",
  id: "error_FirstName"
}
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = {
  class: "form-label",
  for: "inputLastNameAboutThisCar"
}
const _hoisted_19 = {
  class: "error_message hide-text",
  id: "error_LastName"
}
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = {
  class: "form-label",
  for: "inputEmailAskAboutThisCar"
}
const _hoisted_22 = {
  class: "error_message hide-text",
  id: "error_Email"
}
const _hoisted_23 = { class: "form-group-nested" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = {
  class: "form-label",
  for: "inputPhoneNumberAskAboutThisCar"
}
const _hoisted_26 = {
  class: "error_message hide-text",
  id: "error_PhoneNumber"
}
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = {
  class: "form-label",
  for: "inputZipCodeLabelAboutThisCar",
  id: "labelForZipCodeAboutCar"
}
const _hoisted_29 = ["aria-label"]
const _hoisted_30 = {
  id: "error-zip",
  class: "error_message hide-text"
}
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = {
  class: "hintTextArea hide-text",
  id: "hintTextArea"
}
const _hoisted_33 = ["placeholder", "aria-label"]
const _hoisted_34 = { class: "form-group Footer" }
const _hoisted_35 = { class: "form-group mb-0" }
const _hoisted_36 = {
  key: 0,
  class: "error_message hide-text",
  id: "Error_btn"
}
const _hoisted_37 = {
  key: 1,
  class: "error_message hide-text",
  id: "Error_btn"
}
const _hoisted_38 = { class: "Footer text-center" }
const _hoisted_39 = { class: "ParagraphParkGray-Light-BodySM" }
const _hoisted_40 = {
  role: "link",
  href: "/terms-conditions",
  target: "_blank",
  "aria-describedby": "audioeye_new_window_message"
}
const _hoisted_41 = {
  role: "link",
  href: "/privacy-policy",
  target: "_blank",
  "aria-describedby": "audioeye_new_window_message"
}
const _hoisted_42 = {
  key: 1,
  class: "ask-us-form"
}
const _hoisted_43 = { class: "popup-con-wrap" }
const _hoisted_44 = { class: "popup-content" }
const _hoisted_45 = { class: "modal-ask-us-header" }
const _hoisted_46 = { class: "modal-title" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "modal_success_icon",
    alt: "illustration Send info Success"
  })
], -1)
const _hoisted_48 = { class: "modal_success_message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_ctx.FirstModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t('srp2.askUsModal.modalTitle')) + " " + _toDisplayString(this.askUsModalTitle), 1),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeAskAboutUsModal()))
          }, [
            _createVNode(_component_v_icon, { icon: "ep-icon-close" })
          ])
        ]),
        _createElementVNode("input", {
          type: "hidden",
          value: _ctx.askUsVehicle?.vin,
          id: "selectedVehicleVin"
        }, null, 8, _hoisted_4),
        _createElementVNode("input", {
          type: "hidden",
          value: _ctx.askUsVehicle?.make,
          id: "selectedVehicleMake"
        }, null, 8, _hoisted_5),
        _createElementVNode("input", {
          type: "hidden",
          value: _ctx.askUsVehicle?.model,
          id: "selectedVehicleModel"
        }, null, 8, _hoisted_6),
        _createElementVNode("input", {
          type: "hidden",
          value: _ctx.askUsVehicle?.year,
          id: "selectedVehicleYear"
        }, null, 8, _hoisted_7),
        _withDirectives(_createElementVNode("input", {
          type: "hidden",
          id: "isEmailPhone",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isBoth) = $event))
        }, null, 512), [
          [_vModelText, _ctx.isBoth]
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('srp2.askUsModal.bodyTitle')), 1),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('srp2.askUsModal.bodyDescription')), 1)
        ]),
        _createElementVNode("form", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('srp2.askUsModal.firstNameLabel')), 1),
                _createElementVNode("input", {
                  onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInputFocus && _ctx.onInputFocus(...args))),
                  onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onInputBlur && _ctx.onInputBlur(...args))),
                  onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validateFirstName && _ctx.validateFirstName(...args))),
                  type: "text",
                  "aria-label": "First name",
                  class: "form-control",
                  id: "inputFirstNameAboutThisCar",
                  placeholder: "",
                  required: "",
                  "aria-labelledby": "labelForFirstNameAboutCar",
                  autocomplete: "given-name"
                }, null, 32),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('srp2.askUsModal.firstNameValidation')), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('srp2.askUsModal.lastNameLabel')), 1),
                _createElementVNode("input", {
                  onFocus: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onInputFocus && _ctx.onInputFocus(...args))),
                  onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onInputBlur && _ctx.onInputBlur(...args))),
                  onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.validateLastName && _ctx.validateLastName(...args))),
                  type: "text",
                  "aria-label": "Last name",
                  class: "form-control",
                  id: "inputLastNameAboutThisCar",
                  placeholder: "",
                  required: "",
                  autocomplete: "family-name"
                }, null, 32),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('srp2.askUsModal.lastNameValidation')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('srp2.askUsModal.emailLabel')), 1),
            _createElementVNode("input", {
              onFocus: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onInputFocus && _ctx.onInputFocus(...args))),
              onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onInputBlur && _ctx.onInputBlur(...args))),
              type: "email",
              "aria-label": "Ask About This Car Email",
              class: "form-control",
              id: "inputEmailAskAboutThisCar",
              placeholder: "",
              required: "",
              autocomplete: "email"
            }, null, 32),
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('srp2.askUsModal.emailValidation')), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('srp2.askUsModal.phoneNumberLabel')), 1),
              _createElementVNode("input", {
                onFocus: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onInputFocus && _ctx.onInputFocus(...args))),
                onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onInputBlur && _ctx.onInputBlur(...args))),
                onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.validatePhoneNumber && _ctx.validatePhoneNumber(...args))),
                type: "text",
                "aria-label": "Phone Number",
                inputmode: "numeric",
                class: "form-control PhoneNumberFormat",
                id: "inputPhoneNumberAskAboutThisCar",
                placeholder: "",
                maxlength: "14",
                autocomplete: "tel"
              }, null, 32),
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('srp2.askUsModal.phoneNumberValidation')), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('srp2.askUsModal.zipLabel')), 1),
              _createElementVNode("input", {
                onFocus: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onInputFocus && _ctx.onInputFocus(...args))),
                onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onInputBlur && _ctx.onInputBlur(...args))),
                onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.validateZipCode && _ctx.validateZipCode(...args))),
                type: "text",
                "aria-label": _ctx.$t('srp2.askUsModal.zipLabel'),
                inputmode: "numeric",
                class: "form-control",
                id: "inputZipCodeAboutThisCar",
                required: "",
                placeholder: "",
                maxlength: "5",
                "aria-labelledby": "labelForZipCodeAboutCar",
                autocomplete: "postal-code"
              }, null, 40, _hoisted_29),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('srp2.askUsModal.zipValidation')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('srp2.askUsModal.optionalMessage')), 1),
            _createElementVNode("textarea", {
              onFocus: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.TextAreaFocus && _ctx.TextAreaFocus(...args))),
              onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.TextAreaFocusOut && _ctx.TextAreaFocusOut(...args))),
              type: "text",
              id: "comments",
              name: "comments",
              class: "form-control textarea",
              placeholder: _ctx.$t('srp2.askUsModal.optionalMessage'),
              maxlength: "1200",
              "aria-label": _ctx.$t('srp2.askUsModal.optionalMessage')
            }, null, 40, _hoisted_33)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_v_btn, {
                id: "btn-form",
                text: "Send my question",
                onClick: _ctx.handleSecondModal
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", null, [
              (_ctx.isBoth === '1')
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t('srp2.askUsModal.validationBothRequired')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t('srp2.askUsModal.formValidation')), 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("p", _hoisted_39, [
              _createTextVNode(_toDisplayString(_ctx.$t('Submitting')) + " ", 1),
              _createElementVNode("a", _hoisted_40, _toDisplayString(_ctx.$t('TermsOfUse')), 1),
              _createTextVNode(" and "),
              _createElementVNode("a", _hoisted_41, _toDisplayString(_ctx.$t('PrivacyPolicy')), 1)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("h4", _hoisted_46, _toDisplayString(_ctx.$t('srp2.askUsModal.successModalTitle')), 1),
              _createElementVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.closeAskAboutUsModal()))
              }, [
                _createVNode(_component_v_icon, { icon: "ep-icon-close" })
              ])
            ]),
            _hoisted_47,
            _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('srp2.askUsModal.successMessage')), 1)
          ])
        ])
      ]))
}